<div class="container">
    <label>{{ label }}</label>
    <div class="bciti-select-notification bciti-select-notification-input"
      [class.validation]="validation"
      [class.pristine]="pristine"
      [class.dirty]="dirty"
      [class.touched]="touched"
      [class.invalid]="invalid"
      [class.valid]="valid"
      (click)="toggleDropdown()" 
      #dropreference
    >
      <ul>
        <li>
          <mat-progress-spinner mode="indeterminate" diameter="20" *ngIf="loading"></mat-progress-spinner>
          <span *ngIf="!loading">
          
            <ng-container *ngIf="value.length else notSelectedLabel">
              {{ value.length }} {{('common.inputs.select-multiple.selected' | translate)}}{{multipleSelectedTranslation()}}
            </ng-container>
            <ng-template #notSelectedLabel>
              {{('common.inputs.select-multiple.not-selected' | translate)}}
            </ng-template>
          </span>
          <span class="icon icon-caret-down"></span>
        </li>
      </ul>
      <app-select-dropdown-notification [reference]="dropreference" #dropdown (onClose)="onBlur($event)">
        <div class="bciti-select-notification bciti-select-notification-dropdown no-margin">
          <ul>
            <ng-container *ngFor="let option of options">
              <li>
                <app-form-checkbox
                    (change)="select(option)"
                    [isChecked]="option.isSelected"
                    [showMessages]="false">
                    {{ option.name[currentLang] }}
                </app-form-checkbox>
              </li>
            </ng-container>
            <ng-container *ngIf="displayAddArea">
              <li class="separator">
                <hr>
              </li>
              <li class="add-aera-button" (click)="openAddAeraDialog()">
                <span class="icon icon-plus"></span> {{ 'pages.collections.dialogs.edit-aeras-dialog.create-title' | translate }}
              </li>
            </ng-container>
          </ul>
        </div>
      </app-select-dropdown-notification>
    </div>
    <div *ngIf="!disableMessages" class="messages">
      <ng-content selector="app-form-error"></ng-content>
      <ng-content selector="app-form-success"></ng-content>
    </div>
</div>